import { useClaimSparkRewardsDialog } from './logic/useClaimSparkRewardsDialog'
import { ClaimSparkRewardsView } from './views/ClaimSparkRewardsView'
import { SuccessView } from './views/SuccessView'
import { Token } from '@/domain/types/Token'

export interface ClaimSparkRewardsDialogContentContainerProps {
  tokensToClaim: Token[]
  closeDialog: () => void
}

export function ClaimSparkRewardsDialogContentContainer({
  tokensToClaim,
  closeDialog,
}: ClaimSparkRewardsDialogContentContainerProps) {
  const { pageStatus, rewardsToClaim, actionsViewState, chainId } = useClaimSparkRewardsDialog({
    tokensToClaim,
  })

  if (pageStatus.state === 'success') {
    return <SuccessView claimedRewards={rewardsToClaim} chainId={chainId} onClose={closeDialog} />
  }

  return <ClaimSparkRewardsView actionsViewState={actionsViewState} claims={rewardsToClaim} chainId={chainId} />
}
